<template>
    <v-flex fill-height>
        <sidemainmenu></sidemainmenu>
        <br />
        <v-progress-linear slot="extension" :indeterminate="true"  v-if="loading" class="ma-0"></v-progress-linear>
        <v-alert :value="alertsuccess" color="success" icon="new_releases">
                {{ alertsmessage }}
        </v-alert>
        <v-alert :value="alerterror" color="error" icon="new_releases">
            <ul>
                <li v-for="error in errors">{{ error }}</li>
            </ul>
        </v-alert>
        <v-layout wrap justify-space-between>
            <v-card  class="mx-auto" min-width="100%">
            <v-card-title>
                <v-layout wrap justify-space-between>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtSfromdate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtsfrdate" label="From Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtsfrdate" @input="dtSfromdate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 md2>
                        <v-menu v-model="dtStodate" :close-on-content-click="false" :nudge-right="40" lazy transition="scale-transition" offset-y full-width min-width="290px">
                            <template v-slot:activator="{ on }">
                                <v-text-field v-model="dtstdate" label="To Date" prepend-icon="event" readonly
                                v-on="on"></v-text-field>
                            </template>
                            <v-date-picker v-model="dtstdate" @input="dtStodate = false"></v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex xs12 sm6 class="py-2">
                        <v-btn color="info" v-on:click="getData()">
                            <span>Search</span>
                            <v-icon>search</v-icon>
                        </v-btn>
                        <v-btn color="success" v-on:click="seen = !seen">
                            <span>Add New / List</span>
                            <v-icon>add</v-icon>
                        </v-btn>
                        <v-btn color="error" v-on:click="clearData()">
                            <span>Clear</span>
                            <v-icon>loop</v-icon>
                        </v-btn>
                      </v-flex>
                    <v-flex xs12 md2>
                        <h3 class="py-4">CONTAINER GATE IN</h3>
                    </v-flex>
                </v-layout>
            </v-card-title>
            <v-card-text>
                <v-card v-if="seen">
                    <v-card-title>
                        <export-excel
                            title = "VCFS Gate In"
                            :data   = "gatein_details">
                            <v-btn color="cyan">
                            <v-icon color="white">file_copy</v-icon>
                        </v-btn>
                        </export-excel>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="gatein_details" :search="search" class="elevation-1" :rows-per-page-items = "[15, 25, 50, 100]">
                        <template v-slot:items="props">
                            <td>{{ props.index + 1 }}</td>
                            <td v-on:click="passPrint(props.item.gatein_id)"><v-icon >print</v-icon></td>
                            <td class="text-xs-right">{{ props.item.cont_no }}</td>
                            <td class="text-xs-right">{{ props.item.sizetype }}</td>
                            <td class="text-xs-right">{{ props.item.in_date}}</td>
                            <td class="text-xs-right">{{ props.item.seal_no }}</td>
                            <td class="text-xs-right">{{ props.item.igm_no }}</td>
                            <td class="text-xs-right">{{ props.item.bl_no }}</td>
                            <td class="text-xs-right">{{ props.item.line }}</td>
                            <td class="text-xs-right">{{ props.item.vessel }}</td>
                            <td class="text-xs-right">{{ props.item.voyage_no }}</td>
                            <td class="text-xs-right">{{ props.item.truck_no }}</td>
                            <td class="text-xs-right">{{ props.item.transporter }}</td>
                            <td class="text-xs-right">{{ props.item.eir_no }}</td>
                            <td class="text-xs-right">{{ props.item.cargo_description }}</td>
                            <td class="text-xs-right">{{ props.item.is_scanning }}</td>
                            <td class="text-xs-right">{{ props.item.is_damaged }}</td>
                            <td class="text-xs-right">{{ props.item.pass_no }}</td>
                            <td class="text-xs-right">{{ props.item.cont_ref_no }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                Your search for "{{ search }}" found no results.
                            </v-alert>
                        </template>
                    </v-data-table>
                </v-card>
                <v-card  v-else>
                    <v-form v-model="valid" ref="form">
                    <v-card-text class="mx-auto">
                        <v-container grid-list-xl>
                            <v-layout wrap justify-space-between>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtScont_no" label="Search By Container No. 1" required ></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-text-field v-model="txtScont_no1" label="Search By Container No. 2"></v-text-field>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <v-btn  color="info" v-on:click="getSContData()">Search<v-icon right dark>search</v-icon></v-btn>
                                </v-flex>
                            </v-layout>
                            <v-card justify-center>
                            <v-card-text primary-title>
                                <v-layout>
                                    <v-flex xs12 md3>
                                        <v-datetime-picker label="Select Port Out Time" v-model="dt_portout"></v-datetime-picker>
                                    </v-flex>
                                    <v-flex xs12 md3>
                                        <v-datetime-picker label="Select CFS In Time" v-model="dt_cfsin"></v-datetime-picker>
                                    </v-flex>
                                    <v-flex xs12 md3>
                                        <v-text-field v-model="txttruckno" label="Truck No"   :rules="[(v) => !!v || 'RTO Vehicle is required']" ></v-text-field>
                                    </v-flex>
                                    <v-flex xs12 md3>
                                        <v-select v-model="cbotransporter" :items="transporter_list" item-value="id"  label="Select Transport Name" :rules="[(v) => !!v || 'Transport Name is required']" item-text="text"></v-select>
                                    </v-flex>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                            <v-card justify-center>
                                <v-card-text primary-title v-for="(container, index) in containers_list" v-bind:key="index">
                                    <v-layout>
                                        <v-flex xs12 md2>
                                            <v-text-field :value=" container.cont_no" label="Container No." readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-text-field :value=" container.sizetype" label="Container No." readonly></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-text-field label="EIR No." v-model="container.eir_no"  :rules="[(v) => !!v || 'EIR No is required']" ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-text-field label="Seal No." v-model="container.seal_no"  :rules="[(v) => !!v || 'Seal No is required']" ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-checkbox v-model="container.is_scanning" label="Is Scanning" required></v-checkbox>
                                        </v-flex>
                                        <v-flex xs12 md2>
                                            <v-checkbox v-model="container.is_damaged" label="Is Damaged" required></v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-card-text>
                            </v-card>
                        
                            <v-card-text class="mx-auto">
                                <v-container grid-list-xl>  
                                    <v-layout wrap justify-space-between>
                                        <v-flex xs12 md4>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                        </v-flex>
                                        <v-flex xs12 md4>
                                            <v-btn color="success" v-bind:disabled="btnDisable" v-on:click="submitData()">Save</v-btn>
                                            <v-btn color="error" v-on:click="clearData()">Clear</v-btn>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-card-text>
                        </v-container>
                    </v-card-text>
                </v-form>
                </v-card>
            </v-card-text>
            </v-card>
        </v-layout>
    <br />
    <bottomfootermenus></bottomfootermenus>
    </v-flex>
</template>


<script>
import sidemainmenu from '@/components/header.vue';
import bottomfootermenus from '@/components/footer.vue';
import DatetimePicker from 'vuetify-datetime-picker';
import moment from 'moment';
import axios from 'axios';
    const toLower = text => {
            return text.toString().toLowerCase()
        }

        const searchByName = (items, term) => {
            if (term) {
              return items.filter(item => toLower(item.name).includes(toLower(term)))
            }

            return items
        }
  export default {
    name: 'gatein',
    data() {
        return {
            error: false,
            valid: false,
            alerterror: false,
            alertsuccess: false,
            alertsmessage: null,
            errors: null,
            seen: true,
            search: null,
            containers_list: [],
            gatein_details: [],
            bls: [],
            dtsfrdate: null,
            dtstdate: null,
            activeVal: "Open",
            btnDisable: false,
            loading: false,
            txtigmno: null,
            dtSfromdate: false,
            chkbox_scan: false,
            chkbox_damage: false,
            dtStodate: false,
            dt_portout: null,
            dt_cfsin: null,
            txtScont_no: null,
            txtScont_no1: null,
            txtsealno: null,
            txtsblno: null,
            txtsline: null,
            txtssizetype: null,
            txtscargo: null,
            txttruckno: null,
            cbotransporter: null,
            txteirno: null,
            crossDomain : true,
            is_searchclicked : false,
            xhrFields: {
                withCredentials: true
            },
            search: '',
            headers: [
              { text: 'S.No', align: 'left', value: 'index' },
              { text: 'Print', align: 'left', value: 'gatein_id' },
              { text: 'Container No.', align: 'right', value: 'cont_no' },
              { text: 'Size Type', align: 'right', value: 'sizetype' },
              { text: 'In Date', align: 'right', value: 'in_date' },
              { text: 'Seal No.', align: 'right', value: 'seal_no' },
              { text: 'IGM No.', align: 'right', value: 'igm_no' },
              { text: 'BL No.', align: 'right', value: 'bl_no' },
              { text: 'Line', align: 'right', value: 'line' },
              { text: 'Vessel', align: 'right', value: 'vessel' },
              { text: 'Voy.', align: 'right', value: 'voyage_no' },
              { text: 'Truck No.', align: 'right', value: 'truck_no' },
              { text: 'Transport Name', align: 'right', value: 'transporter' },
              { text: 'EIR', align: 'right', value: 'eir_no' },
              { text: 'Cargo', align: 'right', value: 'cargo_description' },
              { text: 'Scanned', align: 'right', value: 'is_scanning' },
              { text: 'Damaged', align: 'right', value: 'is_damaged' },
              { text: 'Pass No', align: 'right', value: 'pass_no' },
              { text: 'Ref. No', align: 'right', value: 'cont_ref_no' }
            ]
        }
    },
    mounted:function(){
        this.getData(),
        this.getTransporter()
    },
    components: {
        sidemainmenu,
        bottomfootermenus,
    },
    methods: {
        getData: function () {
            this.loading = true;
            if(this.dtsfrdate !== null && this.dtstdate !== null) {
                this.API_URL = this.$hostname + "/gate_ins?from_date=" + this.dtsfrdate + "&to_date=" + this.dtstdate
            } else {
                this.API_URL = this.$hostname + "/gate_ins?limit=15"
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.loading = false;
                this.gatein_details = response.data;
            }, (error) => {
                this.loading = false;
                this.error = true;
            })
        },
        searchOnTable () {
            this.state = searchByName(this.state, this.search)
        },
        getSContData: function () {
            if (this.txtScont_no1 === null) {
                this.API_URL = this.$hostname + "/search_containers?cont_1=" + this.txtScont_no
            } else {
                this.API_URL = this.$hostname + "/search_containers?cont_1=" + this.txtScont_no + "&cont_2=" + this.txtScont_no1
            }
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                console.log(response);
                this.containers_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        submitData: function() {
            if(!this.$refs.form.validate()) {
                return false
            }
            this.btnDisable = true;
            this.loading = true;
            const terminal_out_time = moment(String(this.dt_portout)).format('YYYY-MM-DD HH:mm:ss')
            // moment($(this.dt_portout).val()).format("YYYY-MM-DD HH:mm:ss")
            const cfs_in_time = moment(String(this.dt_cfsin)).format('YYYY-MM-DD HH:mm:ss')
            alert(terminal_out_time)

            const gatein_data = {'terminal_out_time': terminal_out_time,
                                 'cfs_in_time': cfs_in_time,
                                 'truck_no': this.txttruckno,
                                 'transporter': this.cbotransporter,
                                 'created_by': localStorage.username}
            const data = {
                'crossDomain': true,
                'cont_data': this.containers_list,
                'gin_data': gatein_data
            }
            axios.post(this.$hostname + '/gate_ins', data,
                       { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
                 .then(response => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alertsuccess = true;
                    window.location.reload();
                 }, (error) => {
                    this.btnDisable = false;
                    this.loading = false;
                    this.alerterror = true;
                    console.log(error.response)
                })
        },
        getTransporter: function () {
            this.API_URL = this.$hostname + "/combos/transporter"
            axios.get(this.API_URL, { headers: {"Authorization" : 'jwt ' + localStorage.jwt} })
            .then((response) => {
                this.transporter_list = response.data;
            }, (error) => {
                this.errors = error.response.data.error;
            })
        },
        clearData: function() {
            this.dtsfrdate = null;
            this.dtstdate = null;
            this.txtigmno = null;
            this.dtSfromdate = null;
            this.dtStodate = null;
            this.dt_portout = null;
            this.dt_cfsin = null;
            this.txtScont_no = null;
            this.txtsealno = null;
            this.txtsblno = null;
            this.txtsline = null;
            this.txtssizetype = null;
            this.txtscargo = null;
            this.txttruckno = null;
            this.txttransortname = null;
            this.txteirno = null;
        },
        passPrint: function(ginID) {
            let passPage = this.$router.resolve('/ginpass/' + ginID);
            window.open(passPage.href, '_blank');
        }
    }
  }
</script>

<style lang="stylus" scoped>
      .v-progress-circular
        margin: 1rem
    .loading-overlay 
        z-index: 10
        top: 0
        left: 0
        right: 0
        position: absolute
        width: 100%
        height: 100%
        background: rgba(255, 255, 255, 0.9)
        display: flex
        align-items: center
        justify-content: center
      
</style>
